module.exports = __webpack_public_path__ + "static/media/arrow_right.3da3d765.svg";